export default __webpack_public_path__ + "static/media/news72.457228eb.jpg";